import React, { createContext, useContext, useMemo, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userData, setUserData] = useState({
        email: "",
        groups: [],
        firstName: "",
        lastName: "",
        sub: "",
    });
    const [csrfToken, setCsrfToken] = useState(null);

    const value = useMemo(
        () => ({
            isAuthenticated,
            setIsAuthenticated,
            userData,
            setUserData,
            csrfToken,
            setCsrfToken,
        }),
        [isAuthenticated, userData, csrfToken]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
}

export default AuthContext;